import { Definition, Ref } from '../../../framework/infra'
import Person from '../../person/Person'

export default class Contact extends Ref {
    
    static definitions = {
        person: { ref: Person }
    }
}
